import { signOut } from "firebase/auth"; // Importeer de Firebase signOut functie
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../firebase"; // Zorg ervoor dat je Firebase auth importeert
import zuidzorglogo from "../images/zuidzorg.logo.png";
import Clock from "./clock";
import "./menu.css";

const Menu = () => {
  const navigate = useNavigate();
  const [greeting, setGreeting] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const updateGreeting = () => {
      const hour = new Date().getHours();
      if (hour < 12) {
        setGreeting("Goedemorgen");
      } else if (hour < 18) {
        setGreeting("Goedemiddag");
      } else {
        setGreeting("Goedenavond");
      }
    };

    updateGreeting();
    const intervalId = setInterval(updateGreeting, 60000);

    return () => clearInterval(intervalId);
  }, []);

  // Controleer of de gebruiker is ingelogd
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsAuthenticated(!!user); // Als er een gebruiker is ingelogd, zet isAuthenticated naar true
    });

    return () => unsubscribe(); // Cleanup listener bij unmounten van het component
  }, []);

  // Functie voor uitloggen
  const handleLogout = async (e) => {
    e.preventDefault(); // Voorkom standaardgedrag van de link
    try {
      await signOut(auth); // Firebase signOut functie aanroepen
      console.log("Succesvol uitgelogd");
      navigate("/login"); // Na uitloggen doorverwijzen naar de loginpagina
    } catch (error) {
      console.error("Error bij uitloggen:", error);
    }
  };

  return (
    <div className="menu">
      <div className="logo-container">
        <span>
          <img className="zzlogo" src={zuidzorglogo} alt="Logo" />
        </span>
        <span className="name">
          <h2>{greeting}&nbsp;</h2>
        </span>
        <button
          className="hamburger"
          onClick={() => setIsMenuOpen((prev) => !prev)}
        >
          ☰
        </button>
      </div>

      <ul className={`menu-list ${isMenuOpen ? "open" : ""}`}>
        {isAuthenticated && (
          <li>
            <Link
              to="/berichten"
              className="menu-item"
              onClick={() => setIsMenuOpen(false)}
            >
              Berichten
            </Link>
          </li>
        )}
        {isAuthenticated && (
          <li>
            <Link
              to="/apps"
              className="menu-item"
              onClick={() => setIsMenuOpen(false)}
            >
              Apps
            </Link>
          </li>
        )}
        {isAuthenticated && (
          <li>
            <Link
              to="/"
              onClick={(e) => {
                handleLogout(e);
                setIsMenuOpen(false);
              }}
            >
              Uitloggen
            </Link>
          </li>
        )}
        {/* Render inloggen link als de gebruiker niet ingelogd is */}
        {!isAuthenticated && (
          <li>
            <Link to="/login" onClick={() => setIsMenuOpen(false)}>
              Inloggen
            </Link>
          </li>
        )}
        <li className="floatright">
          <Clock />
        </li>
      </ul>
    </div>
  );
};

export default Menu;
